import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ApproveRequestsAction = ({ showApprove, disabled }) => (
  <RibbonMenu
    name="approve"
    icon="thumbs up"
    title="actions.approve"
    onClick={showApprove}
    disabled={disabled}
    className="aridhia-approve-action-menu"
    message="actions.approve"
  />
);

export default ApproveRequestsAction;
